// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"c41f6eea","484":"38d48ca7","551":"66dca899","640":"84e8c56d","828":"3464384d","842":"c4b86bec"}[chunkId] + ".chunk.js";
};